/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* eslint-disable no-shadow */

import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { Button } from "@material-ui/core";
import brightcovePlayerLoader from "@brightcove/player-loader";

import pauseBrightcovePlayer from "../util/pauseBrightcovePlayer";
import pauseTYplayer from "../util/pauseYTplayer";
import pauseVMplayer from "../util/pauseVMplayer";

function VideoPlayer(props) {
  const brightcoveVideo = useRef(null);
  const { video } = props;
  const { brightCoveVideoId, jmId } = video;

  const onMouseOver = (play) => {
    document.querySelector(`.video__${jmId}`).classList.add("in--hover");

    if (brightcoveVideo && brightcoveVideo.current) {
      if (brightcoveVideo.current.getAttribute("data-loaded") === "1") {
        return;
      }

      brightcovePlayerLoader({
        refNode: `#brightcoveVideo${jmId}`,
        accountId: process.env.REACT_APP_BRIGHTCOVE_ACCOUNT_ID,
        playerId: process.env.REACT_APP_BRIGHTCOVE_PLAYER_ID,
        embedId: "default",
        videoId: brightCoveVideoId,
        onSuccess: (success) => {
          document.querySelector(`.video__${jmId}`).classList.add("in--play");
          if (brightcoveVideo && brightcoveVideo.current) {
            brightcoveVideo.current.setAttribute("data-loaded", "1");
            success.ref.muted(true);
            play && success.ref.play();
          }
          success.ref.on("playing", () => {
            pauseBrightcovePlayer(`brightcoveVideo${jmId}`);
            pauseTYplayer("");
            pauseVMplayer();
            document.querySelector(`.video__${jmId}`).classList.add("in--play");
          });
        },
        onFailure: (failure) => {
          console.log(failure);
        }
      });
    }
  };

  const onMouseOut = () => {
    document.querySelector(`.video__${jmId}`).classList.remove("in--hover");
  };

  useEffect(() => {
    return () => {
      if (brightcovePlayerLoader && Boolean(brightcovePlayerLoader.reset)) {
        brightcovePlayerLoader.reset();
      }
    };
  }, []);

  return (
    <div>
      <div
        className="player__wrapper"
        id={`brightcoveVideo${jmId}`}
        role="presentation"
        onMouseOut={onMouseOut}
        ref={brightcoveVideo}
        data-loaded="0"
      />
      <Button
        className="vjs-big-play-button"
        id={`play-${video.wirePlatformVideoId}`}
        onClick={() => onMouseOver(true)}
      />
    </div>
  );
}

VideoPlayer.propTypes = {
  video: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired
};

export default VideoPlayer;
